module.exports = __webpack_public_path__ + "img/p08.9bf5b221.jpg";